var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, firstImageProperty } from '@shapeable/utils';
import { Image } from '../elements/image';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
var cls = classNames('organisation-card-image');
export var OrganisationCardImageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(4))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    object-fit: contain;\n    max-width: 200px;\n    height: 100px;\n  "], ["\n    object-fit: contain;\n    max-width: 200px;\n    height: 100px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(Image)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var OrganisationCardImage = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var activeThemeMode = useActiveThemeMode();
  var isInverted = activeThemeMode.themeMode === 'dark';
  var image = firstImageProperty(entity, [isInverted ? 'logoInverted' : 'logo', 'openGraph.image.thumbnails.card', 'openGraph.image']);
  if (!image) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, {
    image: image
  }));
};
OrganisationCardImage.defaultProps = OrganisationCardImageDefaultProps;
OrganisationCardImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;